<template>
  <div>
    <slot name="addButton">
      <v-btn
        color="primary"
        @click.stop="showDialog = true"
      >
        New Share Option
      </v-btn>
    </slot>
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>New Share Option</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>
              <v-form
                ref="form"
                v-model="isValid"
                aria-label="New Share Option"
                class="form-share"
              >
                <v-text-field
                  v-model="name"
                  :rules="rules.text"
                  label="Name"
                  :counter="MAX_LENGTH"
                  required
                  autofocus
                  clearable
                />
                <v-text-field
                  v-model="email"
                  :rules="rules.text"
                  label="Email"
                  :counter="MAX_LENGTH"
                  required
                  clearable
                />
                <v-text-field
                  v-model="address"
                  :rules="rules.text"
                  label="Address"
                  :counter="MAX_LENGTH"
                  required
                  clearable
                />
                <v-text-field
                  v-model="numberOfShares"
                  :rules="rules.number"
                  label="Number of Shares"
                  type="number"
                  min="1"
                  required
                />
                <v-text-field
                  v-model="strikePrice"
                  :rules="rules.number"
                  label="Strike Price"
                  prefix="$"
                  type="number"
                  min="0"
                  required
                />
                <v-select
                  v-model="typeClass"
                  :items="validTypeOptions"
                  label="Share Type"
                  required
                />
                <v-text-field
                  v-model="dateOfIssue"
                  label="Date of Issue"
                  type="date"
                  required
                />
                <v-text-field
                  v-model="valuation"
                  :rules="rules.number"
                  prefix="$"
                  label="Valuation"
                  type="number"
                  min="0"
                />
                <v-textarea
                  v-model="vestingConditions"
                  label="Vesting Condition"
                  placeholder="Vesting Condition"
                  rows="2"
                />
                <v-textarea
                  v-model="notes"
                  label="Notes"
                  placeholder="Notes"
                  rows="2"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            large
            @click="showDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="loading"
            color="primary"
            large
            @click.stop="onSubmitData"
          >
            Add Share Option
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'UpdateShareOption',
  data: function () {
    return {
      loading: false,
      showDialog: false,
      isValid: false,
      numberOfShares: 1,
      valuation: undefined,
      strikePrice: undefined,
      name: undefined,
      email: undefined,
      dateOfIssue: undefined,
      address: undefined,
      notes: undefined,
      vestingConditions: undefined,
      validTypeOptions: ['Option', "ESOP's SAFE Agreements", 'Convertible Notes'],
      typeClass: 'Option',
      MAX_LENGTH: 120,
      rules: {
        text: [value => this.rulesAction(value, 'text')],
        number: [value => this.rulesAction(value, 'number')]
      }
    }
  },
  methods: {
    onSubmitData() {
      if (this.isValid) {
        this.loading = true
        this.$handlingError('Failed to add new share option',
          () => this.$api.addShareOption({
            shareTypeClass: this.typeClass,
            name: this.name,
            email: this.email,
            address: this.address,
            dateOfIssue: this.dateOfIssue,
            numberOfShares: this.numberOfShares,
            strikePrice: this.strikePrice,
            relevantValuation: this.valuation,
            vestingConditions: this.vestingConditions || '',
            otherNotes: this.notes || ''
          })
            .then(() => {
              this.showDialog = false
              this.$showSuccessbar('Share option added!')
              this.$emit('onSubmitData')
              this.$refs.form.reset()
            })
            .finally(() => {
              this.loading = false
            })
        ).catch(() => {})
      }
    },
    rulesAction(value, type) {
      if (!value) {
        return 'This field is required.'
      }

      switch (type) {
      case 'text':
        return value.length <= this.MAX_LENGTH || `Max ${this.MAX_LENGTH} characters`
      case 'number':
        return (Number.isInteger(parseFloat(value)) && parseInt(value) > 0) || 'Just whole numbers greater than 0 are accepted'
      }
    }
  }
}
</script>
